// src/redux/accountSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 🔹 Thunk for fetching account data
export const fetchAccount = createAsyncThunk(
  "account/fetchAccount",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("https://v4.dhundhoo.com/v2/account/my", {
        headers: {
          "x-dhundhoo-session": token,
        },
      });
      return response.data; // return data to reducer
    } catch (error) {
      const status = error.response?.status;
      if (status === 400 || status === 401) {
        localStorage.removeItem("token");
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const accountSlice = createSlice({
  name: "account",
  initialState: {
    data: null,
    loading: false,
    error: null,
    orgEntity: null,   // 👈 new state
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;

        state.orgEntity = action.payload?.orgInfo?.entities || null;
      })
      .addCase(fetchAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accountSlice.reducer;
